import React, { HTMLAttributes, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import Layout from "components/Layout";
import Bgimg from "@/assets/images/academy/nft-3.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  useEffect(() => {
    const htmlEl = document.documentElement;
    htmlEl.style.fontSize = "39px";
  }, []);

  return (
    <Layout>
      <div className={cx(styles.nft, className)}>
        <img src={Bgimg} />
        <ul>
          <li>
            <div>
              <h2>What's to stop me from taking a screenshot of someone else's NFT?</h2>
              <h4>
                Yes, it is true. Technically you could do this. Similarly, you could buy a print of a Monet painting, but that doesn't mean that you have the
                original. Everytime an NFT has been sold, the recording of the transaction is automatically in the blockchain. Ensuring that the originality and
                ownership to the owner as transactions on the blockchain can not be altered but can be viewed in the public domain. This public archive of
                transactional history
              </h4>
              <h4>Which means that when there is a new owner, the ownership can be proven in the blockchain.</h4>
              <h4>
                <p className={cx(styles.dot, className)}></p>
                Many wonder, "Can't I screenshot the NFT without purchasing?" This is true, but you would not be able to sell it at the value of the original.
                Similarly, if you took a photo of the Mona Lisa it would be challenging to find a collector. Every time the NFT moves on the secondary market,
                the new owner and the price paid is automatically recorded on the blockchain, which is a digital archive of transactions no one can alter and
                everyone can see. The idea is that by having these certificates of authenticity be publicly available for everyone to view online, NFTs can
                guarantee the provenance of any asset they are connected to.
              </h4>
            </div>
          </li>
        </ul>
      </div>
    </Layout>
  );
};

export default observer(Main);
// export default Main;
